import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import LoginView from '@/views/LoginView.vue';
  import { computed, onMounted, ref } from 'vue';
  import { getSession } from '@/indexedDB';
  import { DB } from '@/types';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  setup(__props) {

  const db = ref<DB | null>(null);
  const isAuthApp = computed(() => !!(db.value && db.value?.token));

  onMounted(async () => {
    db.value = await getSession('user');
  });

return (_ctx: any,_cache: any) => {
  return (isAuthApp.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "body")
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(LoginView)
      ]))
}
}

})